<template>
  <hr
    :style="dividerStyle"
    class="divider"
  >
</template>

<script>
export default {
  name: 'Divider',
  props: {
    color: {
      type: String,
      default: '#B4BCC1'
    },
    height: {
      type: String,
      default: '2px'
    },
    width: {
      type: String,
      default: '100%'
    },
  },
  computed: {
    dividerStyle() {
      return {
        backgroundColor: this.color,
        width: this.width,
        height: this.height,
      }
    }
  }
}
</script>

<style scoped>
.divider {
  border: none;
  margin: 24px 0;
}
</style>
